import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationCheckService } from 'src/app/services/auth/authentication-check.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SigninComponent implements OnInit {
  loginForm;
  errorMessage: Boolean = true;
  message = "";
  userRole = 1
  isotpInput = true;
  submitOtpbtn = true;
  Getotpbtn = false
  mobileNo = '';
  mobilenoError = false;
  otpError = false;
  otp = '';
  userID = '';
  roles = [
    {
      role_id:1,
      user_name : 'Hubadmin'
    },
    {
      role_id:7,
      user_name : 'Agent'
    },
    {
      role_id:8,
      user_name : 'Reporting Manager'
    },
    {
      role_id:9,
      user_name : 'Branch Manager'
    }
  ]
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private router: Router,
    private formBuilder: FormBuilder,
    private auth: AuthenticationCheckService,
    private toast: ToastClientService
  ) {

    this.loginForm = formBuilder.group({
      username: ['', Validators.compose([
        Validators.required
      ])],
      password: ['', Validators.compose([
        Validators.required,
        Validators.minLength(6)
      ])],
    });
    this.loginForm.valueChanges
      .subscribe(data => {

      });
  }

  ngOnInit() {
    // this.testApi();
  }



  login(formData) {
    if (this.loginForm.invalid) {
      console.log()
      this.errorMessage = false;
      if (formData.username == "" && formData.password == "") {
        this.message = "Please enter the username and password"
      } else if (formData.username == "") {
        this.message = "Please enter the username"

      } else {
        this.message = "Please enter the password"

      }
    } else {
      let apiUrl = this.apiConfig.login;
      let body = JSON.stringify({ "LoginForm": { "username": formData.username, "password": formData.password } });
      this.apiService.post(apiUrl, body)
        .subscribe((res: any) => {
          if (res.status == 200) {
            this.errorMessage = true;
            let body = res.body;
            this.toast.Success('Login successful');
            localStorage.setItem("user_name", (res.body.data.user_name));
            localStorage.setItem("user_id", (res.body.data.id));
            this.auth.saveAuth(body.data.access_token);
            // this.router.navigate(["branch-manager"]);
            // return
            if (body.data.user_role == 1) {
              this.router.navigate(["hubAdmin"]);
            }
            else if (body.data.user_role == 7) {
              this.router.navigate(["agent"]);
            }
            else if (body.data.user_role == 8) {
              // this.router.navigate(["teamleader"]);
              this.router.navigate(["reporting-dashboard"]);
            }
            else if (body.data.user_role == 9) {
              this.router.navigate(["branch-manager"]);

            }
            else {
              this.toast.Success('You dont have access to this module');
            }
          }
        }, err => {
          this.errorMessage = false;
          // console.log('err', err);
        })
    }

  }
  isValid(field): boolean {
    let isValid: boolean = false;

    // If the field is not touched and invalid, it is considered as initial loaded form. Thus set as true
    if (this.loginForm.controls[field].touched == false) {
      isValid = true;
    }
    // If the field is touched and valid value, then it is considered as valid.
    else if (this.loginForm.controls[field].touched == true && this.loginForm.controls[field].valid == true) {
      isValid = true;
    }
    return isValid;
  }
  getOTP(){
    let payload = {
      username : this.mobileNo.toString()
    }
    if(this.mobileNo == '' || this.mobileNo.toString().length != 10){
      this.mobilenoError = true;
      return
    }
    
    this.apiService.post(this.apiConfig.bsmLogin, payload).subscribe((res : any)=>{
      console.log(res)
      this.isotpInput = false;
      this.Getotpbtn = true;
      this.submitOtpbtn = false
      this.mobilenoError = false
      this.userID = res.body.data.user_id
    },err=>{
      console.log(err)
    })

  }
  submitOTP(){
    if(this.otp == '' || this.otp.toString().length != 6){
      this.otpError = true;
      return
    }
    let payload = {
      user_id:this.userID,
      otp:this.otp.toString()
    }
    this.apiService.post(this.apiConfig.bsmOtp , payload).subscribe((res : any)=>{
      console.log(res)
      localStorage.setItem("user_name", (res.body.data.user_name));
      localStorage.setItem("user_id", (res.body.data.id));
      this.auth.saveAuth(res.body.data.access_token);
      this.router.navigate(["branch-manager"]);
    })
  }
  resendOTP(){
    let payload = {
      program_id:1,
      user_id:this.userID,
      mobile_no:this.mobileNo.toString(),
    }
    this.apiService.post(this.apiConfig.bsmResendotp , payload).subscribe((res : any)=>{
      console.log(res)
      this.toast.Success('otp is send your mobile')
    })
  }
}


